import { render, staticRenderFns } from "./HolmyCalendar.vue?vue&type=template&id=b7275c50&scoped=true&"
import script from "./HolmyCalendar.vue?vue&type=script&lang=js&"
export * from "./HolmyCalendar.vue?vue&type=script&lang=js&"
import style0 from "./HolmyCalendar.vue?vue&type=style&index=0&id=b7275c50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7275c50",
  null
  
)

export default component.exports